import { motion } from "framer-motion";
import React from "react";

interface ModalWrapperProps {
    children: React.ReactNode;
    onClose: () => void;
}

const ModalWrapper = ({ children, onClose }: ModalWrapperProps) => {
    const handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={handleBackgroundClick} 
        >
            <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden"
            >
                {children}
            </motion.div>
        </motion.div>
    );
};

export default ModalWrapper;